"use client";
import { getVisuallyHiddenStyle } from "../../visually-hidden/visually-hidden.js";
import { getDocument } from "@ariakit/utils";
//#region src/dialog/utils/prepend-hidden-dismiss.ts
function prependHiddenDismiss(container, onClick) {
	const button = getDocument(container).createElement("button");
	button.type = "button";
	button.tabIndex = -1;
	button.textContent = "Dismiss popup";
	Object.assign(button.style, getVisuallyHiddenStyle());
	button.addEventListener("click", onClick);
	container.prepend(button);
	const removeHiddenDismiss = () => {
		button.removeEventListener("click", onClick);
		button.remove();
	};
	return removeHiddenDismiss;
}
//#endregion
export { prependHiddenDismiss };

//# sourceMappingURL=prepend-hidden-dismiss.js.map